import { AlertType } from '$shared/components';

export class AlertOption {
  public closeIn?: number | undefined;
  public type?: string = AlertType.Info;
  public hasAction?: boolean = false;
  public actionLabel?: string | undefined;
  public reasons?: string[] = [];

  public get hasReasons(): boolean {
    return Array.isArray(this.reasons) && this.reasons.length !== 0;
  }

  public setProps(hasAction?: boolean, actionLabel?: string, closeIn?: number): void {
    this.hasAction = !!hasAction;
    actionLabel && (this.actionLabel = actionLabel);
    closeIn && (this.closeIn = closeIn);
  }

  static from(
    type: AlertType,
    closeIn?: number,
    hasAction?: boolean,
    actionLabel?: string
  ): AlertOption {
    const option = new AlertOption();
    option.type = type;
    option.setProps(hasAction, actionLabel, closeIn);
    return option;
  }

  static warnAlert(hasAction?: boolean, actionLabel?: string): AlertOption {
    const option = new AlertOption();
    option.type = AlertType.Warn;
    option.setProps(hasAction, actionLabel);
    return option;
  }

  static infoAlert(hasAction?: boolean, actionLabel?: string): AlertOption {
    const option = new AlertOption();
    option.type = AlertType.Info;
    option.setProps(hasAction, actionLabel);
    return option;
  }

  static errorAlert(hasAction?: boolean, actionLabel?: string): AlertOption {
    const option = new AlertOption();
    option.type = AlertType.Error;
    option.setProps(hasAction, actionLabel);
    return option;
  }

  static errorAlertWithReason(reasons?: string[]): AlertOption {
    const option = new AlertOption();
    option.type = AlertType.Error;
    Array.isArray(reasons) && (option.reasons = reasons);
    return option;
  }
}
